// import utils from './utils'
// const isMobile = utils.isMobile()
// const size = isMobile ? 37.5 : 192; //设计稿宽度%10
// const designWidth = isMobile ? 375 : 1920

// // 设置rem 函数
// function setRem() {
//   //计算出 比例来 当前分辨率的宽%设计稿宽度
//   const scale = window.screen.width / designWidth;
//   // 给根元素设置font-size
//   document.documentElement.style.fontSize =
//     size * Math.min(scale, 2) + "px";
// }
// setRem();
window.onresize = function () {
  // setRem();
  // location.reload()
};